import { useEffect } from 'react';
import { MemberIndex } from 'react-components/member-index/MembersIndex';
import {
  Navigate,
  NavigateOptions,
  useNavigate,
  useParams,
} from 'react-router-dom';
import {
  selectSelectedTeamMemberId,
  selectTeamMember,
} from 'redux/slices/selectedMemberSlice';
import { useAppDispatch, useAppSelector } from 'redux/store-hooks';
import { Routes, SyncHook } from '../route-types';

export const MEMBER_LIST_PREFIX_PATH = '/member-list';

const useSyncHook: SyncHook = () => {
  const { guideId: routeGuideId } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const reduxGuideId = useAppSelector(selectSelectedTeamMemberId);

  useEffect(() => {
    // Make sure there is a guideId in the route
    // If no guide in the route and there is in the redux, update the route to include a guideId
    if (!routeGuideId && reduxGuideId) {
      navigate(`${MEMBER_LIST_PREFIX_PATH}/guide/${reduxGuideId}`, {
        replace: true,
      });
    }
    // Make sure the selected guide in redux matches the route guideId
    if (routeGuideId && routeGuideId !== reduxGuideId) {
      dispatch(selectTeamMember(routeGuideId));
    }
  }, [routeGuideId, reduxGuideId]);
};

const routes: Routes = [
  {
    path: '/members',
    element: <Navigate to="/member-list" replace />,
  },
  {
    path: '/member-list',
    element: <MemberIndex />,
  },

  {
    path: '/member-list/guide/:guideId',
    element: <MemberIndex />,
  },
];

const useNavigationHooks = () => {
  const navigate = useNavigate();

  return {
    toMemberList: (guideId?: string, options?: NavigateOptions) => {
      // const navigate = useNavigate();
      let url = MEMBER_LIST_PREFIX_PATH;
      if (guideId && guideId !== 'none') {
        url += `/guide/${guideId}`;
      }

      navigate(url, options);
    },
  };
};

export const memberListRouteConfig = {
  routes,
  useSyncHook,
  useNavigationHooks,
};
